import React, { createContext, useContext } from 'react';
import { seoSegmentationListingPage_seoSegmentationDetails_SEOSegmentationDetailsSuccess_segmentationDetails as SEOSegmentationDetailsType } from '@/__generated__/seoSegmentationListingPage';

interface HeroContentContextProps {
  headline: SEOSegmentationDetailsType['headline'];
  subHeadline: SEOSegmentationDetailsType['subHeadline'];
  enrollmentURL: string;
  directoryFirstExperience: boolean;
  userGeoInfo: string;
  isJobSegment: boolean;
}

const initialState: HeroContentContextProps = {
  headline: '',
  subHeadline: '',
  enrollmentURL: '',
  directoryFirstExperience: false,
  userGeoInfo: '',
  isJobSegment: false,
};

const HeroContentContext = createContext<HeroContentContextProps>(initialState);

export const useHeroContent = () => useContext(HeroContentContext);

export const HeroContentProvider: React.FC<HeroContentContextProps> = ({ children, ...props }) => {
  return <HeroContentContext.Provider value={props}>{children}</HeroContentContext.Provider>;
};
